import React, { useEffect, useState } from 'react'
import DataTables from '../../Main/DataTable/DataTables'
import { getCoupons } from '../../../Services/AdminServices/adminUserServices';

const Coupons = () => {

    const columns = [
       
        { name: 'title', selector: row => row.title },
        { name: 'status', selector: row => row.status }
    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)

    const getAllCoupons = async () => {
        setLoading(true)
        const response = await getCoupons();
        if (response?.code === 200) {
            setData(response?.result?.discountVouchers?.original?.data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }
    // Fetch all coupons on component mount
    // This will run only once when the component is mounted
    // and will not run again unless the component is unmounted and remounted.
    useEffect(() => { getAllCoupons(); }, [])
    

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className='fw-bold mb-0'>Coupons</h3>
                        <p className='text-muted'>Manage Coupons</p>
                    </div>


                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <div className="spinner-border text-info" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-12">
                            <DataTables filter={true} columns={columns} data={data} />
                        </div>
                    )}

                </div>
            </div>
        </>
    )
}

export default Coupons